import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { NavigatorView } from './Navigator.styles';
import NavigatorSwitch from './NavigatorSwitch';

function NavigatorScreens(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'NavigatorScreens'),
      children = _useContextSystem.children,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children"]);

  return /*#__PURE__*/React.createElement(NavigatorView, Object.assign({}, otherProps, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(NavigatorSwitch, null, children));
}

export default contextConnect(NavigatorScreens, 'NavigatorScreens');